import { useQuery } from 'react-query';
import { api } from '../../../../static/api';
import { ApiMonthlyStatsResponse, GamesMonthlyStatsParams, IMonthlyStats } from '../../../../types/GameTypes';
import { QueryAliases } from '../../../../types/QueryAliases';
import useAxiosInstance from '../../../axios/useAxiosInstance';

interface useCreatedQuestionsStatisticsProps {
  params: GamesMonthlyStatsParams;
}

const useCreatedQuestionsStatistics = ({ params }: useCreatedQuestionsStatisticsProps) => {
  const axiosInstance = useAxiosInstance();

  const { email, gameType, year } = params;

  const getQueryParams = () => ({
    ...(!!email && { email }),
    ...(!!gameType && { gameType }),
    ...(!!year && { year }),
  });

  const { data, refetch, isSuccess, isLoading, isError } = useQuery(
    [QueryAliases.ALL_GAME_STATISTICS.CREATED_QUESTIONS, email, gameType, year],
    () =>
      axiosInstance.get(api.endpoints.ALL_GAME_STATISTICS.CREATED_QUESTIONS(), {
        params: getQueryParams(),
      }),
  );

  const apiStatistics: ApiMonthlyStatsResponse | undefined = data?.data;

  const iStatistics: IMonthlyStats | undefined = !!apiStatistics
    ? {
        totalCount: apiStatistics.totalCount,
        countByMonth: (apiStatistics.countByMonth ?? []).map(monthItem => ({
          month: monthItem.month,
          count: monthItem.count,
        })),
      }
    : undefined;

  return {
    createdQuestionsStatistics: iStatistics,
    refetch,
    isSuccess,
    isLoading,
    isError,
  };
};

export default useCreatedQuestionsStatistics;
